module.exports = __webpack_public_path__ + "img/logo.0d97e02d.png";